var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12.8555 4L14.2655 5.41L8.68547 11H20.8555V13H8.68547L14.2655 18.59L12.8555 20L4.85547 12L12.8555 4Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
